import React from 'react';
import { getNumberFromString } from '../../../utility/formatNumbers';
import convertUnitMoney from '../../../utility/convertUnitMoney';
import Formula from '../formElements/Formula';
import { memoize } from 'lodash';

function getarg(name) {
  if (typeof name === 'string') {
    const result = name.includes('_ttl')
      ? name.substring(0, name.indexOf('_'))
      : name;
    return result;
  }
  return console.error('Invalid field name used in calculations: ', name);
}

export function calculateTotals(totalsSchema, initialData, rows) {
  const result = {};

  totalsSchema.forEach((field) => {
    const memberarg = getarg(field.name);
    let total = 0;

    // Add a check for value units

    switch (field.source) {
      case 'local':
        total = rows.reduce(
          (sum, row) => sum + getNumberFromString(row[memberarg]),
          0
        );
        break;
      case 'project':
        // Convert percentage into absolute value

        // CHECK THIS LOGIC
        if (initialData[field.name]?.includes('_percent')) {
          const parentField = initialData[field.derivedFrom];
          total =
            (getNumberFromString(parentField) *
              getNumberFromString(initialData[field.name])) /
            100;
        } else {
          total = getNumberFromString(initialData[field.name]);
        }
        break;
      case 'projectUsers':
        // TBD add logic for fields with precent/unit options if necessary
        total = Object.values(initialData[field.name]).reduce(
          (sum, amount) => sum + getNumberFromString(amount),
          0
        );
        break;
      default:
        break;
    }

    result[field.name] = total;
  });

  return result;
}

export function updateMember(tableSchema, initialData, updatedRow) {
  const allUpdates = {};

  // Get data for each field, update only for the current member
  tableSchema.forEach((field) => {
    const numericValue = getNumberFromString(updatedRow[field.name]);
    const allMembers = initialData[field.name];

    if (allMembers) {
      allMembers[updatedRow.uid] = numericValue;
      allUpdates[field.name] = allMembers;
    } else {
      allUpdates[field.name] = { [updatedRow.uid]: numericValue };
    }
  });

  return allUpdates;
}

export function calculateFromTotals(field, projectData, totals, userId) {
  const params = [field, projectData, totals, userId];
  const hasInvalidParams = params.some(
    (param) => typeof param !== 'number' && !param
  );
  if (hasInvalidParams) {
    console.error('Insufficient arguments provided to calculateField');
    return 'N/A';
  }

  // Find arguments for the calculation
  const args = field.derivedFrom.map((arg) => {
    // Check the table's totals first
    if (totals[arg] >= 0) {
      return totals[arg];
    }

    // If no luck, look for the field in Data Vault
    const data = projectData[arg];

    if (data === undefined) {
      return 0;
    }
    if (typeof data === 'object') {
      // Retrieve user-level data
      return data[userId];
    }
    // Return project-level data as is
    return data;
  });

  // Run calculations with the found arguments
  try {
    const result = field.calcFunction(...args);
    if (Number.isNaN(parseInt(result, 10))) return 'N/A';
    return result;
  } catch (err) {
    console.error(`Error in calculations for ${field.name}:`, err);
    return 'N/A';
  }
}

const getArgs = (field, projectData) => {
  return field.derivedFrom.map((arg) => {
    // Look for the field in data
    let data = projectData[arg];
    if (data === undefined || data === null || data === 'N/A') {
      // console.warn(`Couldn't find argument ${arg} for field ${field.name}`);
      return null;
    }

    return convertUnitMoney(data, projectData);
  });
};

export function calculate(field, projectData, returns = 'number') {
  const params = [field, projectData];
  const hasInvalidParams = params.some(
    (param) => typeof param !== 'number' && !param
  );
  if (hasInvalidParams) {
    console.error(
      'Insufficient arguments provided to calculateField: ',
      params
    );
    return null;
  }

  // Find arguments for the calculation
  const args = getArgs(field, projectData);

  // Run calculations with the found arguments
  try {
    const result = field.calcFunction(...args);
    if (typeof result === 'object' && returns === 'object') return result;
    if (result === Infinity) return Infinity;
    if (result === '-Infinity') return -Infinity;
    if (Number.isNaN(parseInt(result, 10))) return null;
    return result;
  } catch (err) {
    console.error(`Error in calculations for ${field.name}:`, err);
    return null;
  }
}

function argumentResolver(field, projectData) {
  const calcArguments = getArgs(field, projectData);
  try {
    const stringified = JSON.stringify([field, ...calcArguments]);
    return stringified;
  } catch (err) {
    console.error(
      'Invalid object passed as argument to memoized function',
      err
    );
    return Date.now().toString();
  }
}

const calculateField = memoize(
  (field, projectData, returns) => calculate(field, projectData, returns),
  argumentResolver
);

export default calculateField;

export function renderFormula(field, result, projectData) {
  // const params = [field, projectData];

  // const hasInvalidParams = params.some(
  //   (param) => typeof param !== 'number' && !param
  // );
  // if (hasInvalidParams) {
  //   console.error(
  //     'Insufficient arguments provided to render formula for: ',
  //     field.name
  //   );
  //   return null;
  // }
  // Find arguments for the calculation
  // const args = getArgs(field, projectData);

  // Run calculations with the found arguments
  try {
    // const formulaLines = field.formula(...args);
    const formulaLines = field.formula(result);
    return <Formula formulaLines={formulaLines} />;
  } catch (err) {
    console.error(`Failed to render formula for ${field.name}:`, err);
    return null;
  }
}
